<template>
  <pop-view @onCloseClick="onCloseClick">
    <div class="return-warehouse">
      <div class="return-warehouse-top">
        <p class="return-warehouse-top-title">设备回库</p>
        <img
          class="return-warehouse-top-close"
          src="@imgs/close-card.png"
          @click="onCloseClick"
        />
      </div>
      <div class="return-warehouse-middle">
        <!-- 第一行：设备属性 + 设备状态 -->
        <div class="form-row">
          <div class="form-field">
            <p class="form-field-title">设备属性：</p>
            <el-select
              v-model="deviceAttribute"
              placeholder="试用"
              class="form-field-select"
              disabled
            >
           
              <el-option label="正式进院" :value="1"></el-option>
              <el-option label="试用" :value="2"></el-option>
            </el-select>
          </div>
          <div class="form-field">
            <p class="form-field-title">设备状态：</p>
            <el-select
              v-model="deviceStatus"
              placeholder="在库"
              class="form-field-select"
              disabled
            >
              <el-option label="在库" :value="1"></el-option>
            </el-select>
          </div>
        </div>

        <!-- 第二行：两个同步回库指环（仅ZG-S01D设备型号显示） -->
        <div class="form-row" v-if="shouldShowRings">
          <div class="form-field">
            <p class="form-field-title">同步回库指环：</p>
            <el-select
              v-model="outboundRing1"
              placeholder="请选择指环"
              class="form-field-select"
              filterable
              clearable
            >
              <el-option
                v-for="ring in ringList"
                :key="ring.value"
                :label="ring.label"
                :value="ring.value"
              ></el-option>
            </el-select>
          </div>
          <div class="form-field">
            <p class="form-field-title">同步回库指环：</p>
            <el-select
              v-model="outboundRing2"
              placeholder="请选择指环"
              class="form-field-select"
              filterable
              clearable
            >
              <el-option
                v-for="ring in ringList"
                :key="ring.value"
                :label="ring.label"
                :value="ring.value"
              ></el-option>
            </el-select>
          </div>
        </div>

        <!-- 第三行：备注 -->
        <div class="form-row">
          <div class="form-field">
            <p class="form-field-title">备注：</p>
            <el-input
              v-model="inboundRemarks"
              type="textarea"
              placeholder="请输入备注"
              class="form-field-textarea"
              :rows="2"
            >
            </el-input>
          </div>
        </div>
        
        <!-- 文案提示区域 (仅ZG-S01D设备显示) -->
        <div class="form-tips" v-if="shouldShowRings">
          <p class="form-tips-title">解除原来之间的关联关系并同时切换到新选择的机构（未选择 则为空）：</p>
          <div class="form-tips-content">
            <p v-if="deviceData">
              <span v-if="deviceData.deviceHospitalName">
                {{ deviceData.model }}（sn：{{ deviceData.deviceSn || '--' }}）与{{ deviceData.deviceHospitalName }}
              </span>
              <span v-else>
                {{ deviceData.model }}（sn：{{ deviceData.deviceSn || '--' }}）不存在 机构关联信息
              </span>
            </p>
            <p v-for="ring in allRingTips" :key="ring.id">
              指环（sn：{{ ring.deviceSn || '--' }}）与{{ ring.hospitalName || '未知机构' }}
            </p>
          </div>
        </div>
      </div>
      <div class="return-warehouse-bottom">
        <button class="return-warehouse-bottom-cancel" @click="onCancelClick">取消</button>
        <button class="return-warehouse-bottom-confirm" @click="onConfirmClick">确定</button>
      </div>
    </div>
  </pop-view>
</template>

<script>
import PopView from "@c/common/pop-view.vue";
import { Select, Option, Input } from "element-ui";

export default {
  components: {
    PopView,
    ElSelect: Select,
    ElOption: Option,
    ElInput: Input,
  },

  props: {
    deviceData: {
      type: Object,
      default: () => ({})
    },
    hospitalList: {
      type: Array,
      default: () => []
    }
  },

  data: function () {
    return {
      deviceAttribute: null, // 从deviceData中获取
      deviceStatus: 1, // 固定为在库
      outboundRing1: null,
      outboundRing2: null,
      inboundRemarks: "",
      ringList: [],
    };
  },

  computed: {
    // 判断是否显示指环选择（仅ZG-S01D设备型号）
    shouldShowRings() {
      return this.deviceData && this.deviceData.model === 'ZG-S01D';
    },

    // 获取初始化的指环关联信息（来自syncOutboundRingHospitals）
    initialRingTips() {
      const tips = [];
      if (this.deviceData && this.deviceData.syncOutboundRingHospitals && Array.isArray(this.deviceData.syncOutboundRingHospitals)) {
        this.deviceData.syncOutboundRingHospitals.forEach(ringData => {
          tips.push({
            id: ringData.id,
            deviceSn: ringData.ringSn || '--',
            hospitalName: ringData.hospitalName || '未知机构'
          });
        });
      }
      return tips;
    },

    // 获取选中的指环提示信息（选择新指环时）
    selectedRingTips() {
      const tips = [];
      if (this.outboundRing1) {
        const ring1 = this.ringList.find(ring => ring.value === this.outboundRing1);
        if (ring1) {
          tips.push({
            id: ring1.value,
            deviceSn: ring1.deviceSn || ring1.label,
            hospitalName: ring1.deviceHospitalName || '未知机构'
          });
        }
      }
      if (this.outboundRing2) {
        const ring2 = this.ringList.find(ring => ring.value === this.outboundRing2);
        if (ring2) {
          tips.push({
            id: ring2.value,
            deviceSn: ring2.deviceSn || ring2.label,
            hospitalName: ring2.deviceHospitalName || '未知机构'
          });
        }
      }
      return tips;
    },

    // 显示的指环信息：如果有选中的指环则显示选中的，否则显示初始的
    allRingTips() {
      // 如果用户选择了新指环，则显示新选择的指环，替换原有的
      if (this.selectedRingTips.length > 0) {
        return this.selectedRingTips;
      }
      // 否则显示初始的指环信息
      return this.initialRingTips;
    }
  },

  async mounted() {
    // 初始化设备属性
    this.initializeDeviceData();
    
    if (this.shouldShowRings) {
      await this.getRingList();
      this.initializeRingSelections();
    }
  },

  methods: {
    initializeDeviceData() {
      // 当deviceAttribute为0时显示为空，否则显示实际值
      const deviceAttr = this.deviceData?.deviceAttribute;
      this.deviceAttribute = deviceAttr === 0 ? null : deviceAttr;

    },
    
    async getRingList() {
      try {
       
        const response = await this.$api.getRingDeviceList({
          deviceStatusList:[2,3]
        });
        this.ringList = response.map(item => ({
          value: item.id,
          label: item.deviceSn,
          deviceSn: item.deviceSn,
          deviceHospitalName: item.deviceHospitalName
        }));
      } catch (error) {
        console.error('获取指环列表失败:', error);
      }
    },

    onCloseClick: function () {
      this.$emit("onCloseClick");
    },

    onCancelClick: function () {
      this.onCloseClick();
    },

    async onConfirmClick() {
      // 验证两个同步回库指环值不能相同
      if (this.outboundRing1 && this.outboundRing2 && this.outboundRing1 === this.outboundRing2) {
        this.$toast.showRed("两个同步回库指环值需要不相同");
        return;
      }

      // 合并指环选择
      const outboundRingIds = [this.outboundRing1, this.outboundRing2].filter(ring => ring !== null);

      try {
        // 构造参数
        const params = {
          id: this.deviceData.id,
          deviceAttribute: this.deviceAttribute,
          deviceStatus: this.deviceStatus,
          outboundRingIds: outboundRingIds.join(','),
          inboundRemarks: this.inboundRemarks,
        };

        // 调用回库接口
        await this.$api.getDeviceOutboundList(params);
        
        this.$toast.showGreen("设备回库成功");
        this.$emit("onConfirmClick", params);
        this.onCloseClick();
      } catch (error) {
        console.error('设备回库失败:', error);
        this.$toast.showRed("设备回库失败");
      }
    },

    initializeRingSelections() {
      // 如果deviceData中有syncOutboundRingHospitals且是数组
      if (this.deviceData && 
          this.deviceData.syncOutboundRingHospitals && 
          Array.isArray(this.deviceData.syncOutboundRingHospitals)) {
        
        const ringHospitals = this.deviceData.syncOutboundRingHospitals;
        
        // 遍历ringHospitals，匹配到ringList中对应的项目
        ringHospitals.forEach((ringData, index) => {
          if (ringData.ringSn) {
            // 在ringList中查找匹配的指环
            const matchedRing = this.ringList.find(ring => ring.deviceSn === ringData.ringSn);
            if (matchedRing) {
              // 根据索引分配到对应的选择框
              if (index === 0) {
                this.outboundRing1 = matchedRing.value;
              } else if (index === 1) {
                this.outboundRing2 = matchedRing.value;
              }
            }
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.return-warehouse {
  width: rem(550);

  &-top {
    width: 100%;
    height: rem(55);
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    box-sizing: border-box;
    padding: rem(0) rem(24);
    display: flex;
    align-items: center;
    justify-content: space-between;

    &-title {
      color: rgba($color: black, $alpha: 0.85);
      font-size: rem(16);
    }

    &-close {
      width: rem(16);
      height: rem(16);
    }
  }

  &-middle {
    color: rgba($color: black, $alpha: 0.85);
    font-size: rem(14);
    line-height: rem(20);
    border-bottom: rem(1) solid rgba($color: black, $alpha: 0.09);
    width: 100%;
    max-height: rem(600);
    overflow-y: auto;
    padding: rem(20) rem(24);
    box-sizing: border-box;

    .required {
      color: #ff4d4f;
    }

    // 创建行容器
    .form-row {
      display: flex;
      gap: rem(20);
      margin-bottom: rem(16);

      .form-field {
        flex: 1;
        display: flex;
        flex-direction: column;
        gap: rem(8);

        &-title {
          font-weight: 500;
          margin: 0;
        }

        &-select {
          ::v-deep .el-input {
            height: rem(32);
          }
        }

        &-textarea {
          ::v-deep .el-textarea__inner {
            min-height: rem(80);
          }
        }
      }
    }
  }

  &-bottom {
    width: 100%;
    height: rem(73);
    box-sizing: border-box;
    padding-top: rem(10);
    padding-right: rem(16);
    display: flex;
    justify-content: flex-end;

    &-confirm {
      color: white;
      background-color: #325FAC;
      font-size: rem(14);
      border-radius: rem(3);
      width: rem(65);
      height: rem(32);
      display: flex;
      align-items: center;
      justify-content: center;
    }

    &-cancel {
      color: rgba($color: #000000, $alpha: 0.65);
      background-color: white;
      font-size: rem(14);
      border-radius: rem(3);
      border: rem(1) solid #e8e8e8;
      width: rem(65);
      height: rem(32);
      margin-right: rem(8);
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
  
  // 文案提示区域样式
  .form-tips {
    margin-top: rem(20);
    padding: rem(12) rem(16);
    background-color: #f6f8fa;
    border: rem(1) solid #e1e4e8;
    border-radius: rem(4);
    color: rgba($color: black, $alpha: 0.65);
    font-size: rem(12);
    line-height: rem(18);

    &-title {
      margin: 0 0 rem(8) 0;
      font-weight: 500;
      color: rgba($color: black, $alpha: 0.85);
    }

    &-content {
      p {
        margin: 0 0 rem(4) 0;
        padding-left: rem(12);
        
        &:last-child {
          margin-bottom: 0;
        }
      }
    }
  }
}
</style>